import { 
    CREATEAPPOINTMENTPATIENT, 
    CREATEAPPOINTMENTVISITER, 
    DELETEAPPOINTMENTPATIENT, 
    DELETEAPPOINTMENTVISITER, 
    GETALLAPPOINTMENT, 
    GETAPPOINTMENTPATIENT, 
    GETAPPOINTMENTPATIENTBYID, 
    GETAPPOINTMENTPATIENTLIKE, 
    GETAPPOINTMENTVISITER, 
    UPDATEAPPOINTMENTPATIENT,
    UPDATEAPPOINTMENTPATIENTACTION,
    UPDATEAPPOINTMENTVISITER, 
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEAPPOINTMENTPATIENT:
            return {
                ...state,
                patientSaveStatus: action.payload.success,
            }
        case GETAPPOINTMENTPATIENT:
                return {
                        ...state,
                        appoinmentpatientList: action.payload.data,
                        }
        case GETAPPOINTMENTPATIENTLIKE:
                return {
                        ...state,
                        appoinmentpatientlikeList: action.payload.data,
                        }
        case GETALLAPPOINTMENT:
                return {
                        ...state,
                        allappoinmentList: action.payload.data,
                        }
        case UPDATEAPPOINTMENTPATIENT:
                return {
                        ...state,
                        appoinmentpatientUpdateStatus: action.payload.success,
                        }
        case UPDATEAPPOINTMENTPATIENTACTION:
                return {
                        ...state,
                        appoinmentpatientactionUpdateStatus: action.payload.success,
                        }    
        case GETAPPOINTMENTPATIENTBYID:
                return {
                        ...state,
                        appoinmentpatientbyidList: action.payload.data,
                        }
        case DELETEAPPOINTMENTPATIENT:
                 return {
                     ...state,
                     appoinmentpatientDeleteStatus: action.payload.success,
                        } 
        case CREATEAPPOINTMENTVISITER:
            return {
                ...state,
                appoinmentvisiterSaveStatus: action.payload.success,
            }
        case GETAPPOINTMENTVISITER:
                return {
                        ...state,
                        appoinmentvisiterList: action.payload.data,
                        }
        case UPDATEAPPOINTMENTVISITER:
                return {
                        ...state,
                        appoinmentvisiterUpdateStatus: action.payload.success,
                        }   

        case DELETEAPPOINTMENTVISITER:
                 return {
                     ...state,
                     visiterDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                             }
                         }